import { Directive, Input, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[clickOutside]',
})
export class ClickOutsideDirective {
    private isClicked = false;
    @Output() clickOutside = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) { }

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        if (!this.isClicked) {
            this.isClicked = true;
            return;
        }
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.isClicked = false;
            this.clickOutside.emit();
        }
    }

}
